import PropTypes from 'prop-types';
import React from 'react';

import { Image, Video } from '$partials/media';

/* =========================================================================  */
/* Component(s) */
/* =========================================================================  */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const MediaOverlay = ({
    caption     = null,
    imageBottom = null,
    imageTop    = null,
    videoBottom = null,
    videoTop    = null
}) => {
    // render
    return (
        <section className='module-media-overlay'>
            <div className='pb10'> {/* space to try account for absolute secondary media element */}
                <div className='pr-gutter mxn-gutter'> {/* outer grid gutter */}
                    <div className='flex flex-wrap relative'>
                        {/* side title */}
                        <div className='absolute top-0 md-relative md-col-2' />

                        {/* content */}
                        <div className='col-12 sm-col-12 md-col-10'>
                            <div className='ml9 sm-ml9 md-ml0'>
                                <div className='px-gutter'>
                                    <figure className='line-height-0'>
                                        <div className='border-rad-10'>
                                            {(imageTop && !videoTop) && (
                                                <Image {...imageTop} />
                                            )}

                                            {videoTop && (
                                                <Video
                                                    autoPlay={true}
                                                    className='height-100 width-100'
                                                    containerClassName='height-100 width-100'
                                                    controls={false}
                                                    loop={true}
                                                    muted={true}
                                                    playsInline={true}
                                                    src={videoTop.url} />
                                            )}
                                        </div>

                                        {caption && (
                                            <figcaption className='type-style-5 mt3'>
                                                {caption}
                                            </figcaption>
                                        )}
                                    </figure>
                                </div>
                            </div>
                        </div>

                        <div
                            className={`col-4 push-left-8 sm-push-left-7${(!imageTop && !videoTop) ? '' : ' absolute bottom-0'}`}
                            style={{ marginBottom: (!imageTop && !videoTop) ? null : '-7.5%' }}>
                            <figure className='line-height-0'>
                                <div className='border-rad-10'>
                                    {(imageBottom && !videoBottom) && (
                                        <Image {...imageBottom} />
                                    )}

                                    {videoBottom && (
                                        <Video
                                            autoPlay={true}
                                            className='height-100 width-100'
                                            containerClassName='height-100 width-100'
                                            controls={false}
                                            loop={true}
                                            muted={true}
                                            playsInline={true}
                                            src={videoBottom.url} />
                                    )}
                                </div>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

/* =========================================================================  */
/* Typing and exports */
/* =========================================================================  */

const propTypes = {
    caption    : PropTypes.string,
    imageBottom: PropTypes.object,
    imageTop   : PropTypes.object,
    videoBottom: PropTypes.object,
    videoTop   : PropTypes.object,
};

MediaOverlay.propTypes = propTypes;

export { MediaOverlay };

export default MediaOverlay;
